export const skymonBlue = "#4686BA";
export const editModeColor = "darkgoldenrod";
export const nonActiveColor = "darkGrey";
export const titleText = "darkGrey";
export const dataText = "#34495E";
export const data2Text = "#5D6D7E"
export const dialogBg = "rgba(33, 47, 60, 0.95)";
